import { Flag } from "lucide-react";
import {
  ProjectPulseParamsSchema,
  defaultProjectPulseParams,
  type ProjectPulseParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { ProjectPulseWidget } from "./Component.js";
import type { ProjectPulseView } from "./types.js";

/**
 * Project Pulse — dashboard data widget (Operations). Saved params are empty;
 * `TView` = resolved `{ projects: PulseProject[] }`. No per-instance editor.
 */
export const projectPulseDef: SqlWidgetDef<
  ProjectPulseParams,
  ProjectPulseView
> = {
  kind: "projectPulse",
  label: "Project Pulse",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 480, h: 320 },
  defaultParams: defaultProjectPulseParams,
  Component: ProjectPulseWidget,
  storage: "sql",
  schema: ProjectPulseParamsSchema,
  accent: "cyan",
  icon: Flag,
  subtitle: "Active improvement work",
  defaultRoster: false,
  category: "single",
  layout: { col: 1, row: 1, width: 480, height: 320 },
  dashboard: {
    icon: Flag,
    defaultWidth: "wide",
    category: "Operations",
  },
};

registerWidget(projectPulseDef);
